export const handleVisNavCardSelect = (opts) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('visual-category-nav.click', opts);
  }
};
